/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Snippet_CommentInputs */

const fr_snippet_comment = /** @type {(inputs: Snippet_CommentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quick Search widget`)
};

const en_snippet_comment = /** @type {(inputs: Snippet_CommentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quick Search widget`)
};

/**
* | output |
* | --- |
* | "Quick Search widget" |
*
* @param {Snippet_CommentInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const snippet_comment = /** @type {((inputs?: Snippet_CommentInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Snippet_CommentInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_snippet_comment(inputs)
	return en_snippet_comment(inputs)
});